<div mat-dialog-content>
  <h2>Kan ikke legge til flere mobilabonnement</h2>
  <p>
    Kan dessverre ikke ha flere abonnementer. Dersom dette er feil kan dere ringe inn til til kundeservice, eller gi oss en
    tilbakemelding.
  </p>
</div>
<div mat-dialog-actions>
  <div class="buttons">
    <app-ice-button class="button" color="secondary" matDialogClose testId="close-max-number-of-subscriptions-dialog-button">
      Den er grei
    </app-ice-button>
  </div>
</div>
